/** Base64 (as PostgREST returns a bytea encoded by the RPC) to bytes. Whitespace is ignored. */
export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64.replace(/\s+/g, ''));
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) out[i] = binary.charCodeAt(i);
  return out;
}

/**
 * Lower-case hex SHA-256 of `bytes`, computed on this device with WebCrypto. The agreement screen shows it and
 * sends it with the signature: the server refuses a signature whose client hash differs from the stored
 * document's, so what the promoter read is provably what he signed.
 */
export async function sha256Hex(bytes: Uint8Array): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', bytes as BufferSource);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
